import styled from '@emotion/styled'
import { Divider } from 'antd'

export const NoMarginDivider = styled(Divider)`
  margin: 0px;
`
